export default __webpack_public_path__ + "static/jonny-ceb53edb5164bb3179863be0a3d8021e.jpg";